import { useLanguage } from "../lang/LanguageContext";
import Header from "../components/Header";
import { MdWorkOutline } from "react-icons/md";
import { HiOutlineAcademicCap } from "react-icons/hi2";
import FeaturedPublications from "../components/FeaturedPublications";

export default function Experience() {
  const { strings } = useLanguage();
  const experiences = strings.experiencePage.parcours;
  const exp2 = strings.experiencePage.rexp;

  return (
    <main className="min-h-screen bg-white text-gray-900 font-sans mb-12">
      <Header />
      <section className="mt-12 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {exp2.title}
        </h2>

        <ol className="space-y-8 max-w-4xl mx-auto px-6 border-s border-gray-200 pl-6 relative">
          {exp2.timeline.map((exp, index) => (
            <li key={index} className="mb-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white">
                {exp.type === "work" ? (
                  <MdWorkOutline className="w-4 h-4 text-blue-700" />
                ) : (
                  <HiOutlineAcademicCap className="w-5 h-5 text-blue-700" />
                )}
              </span>
              <h2 className="text-xl font-semibold">
                {exp.role} —{" "}
                <span className="text-gray-700">{exp.institution}</span>
              </h2>
              <p className="text-sm text-gray-500 italic">
                {exp.location} — {exp.date}
              </p>
              <p className="mt-2 text-gray-700">{exp.description}</p>
            </li>
          ))}
        </ol>
      </section>
      <section className="mt-12 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {experiences.title}
        </h2>

        <ol className="space-y-8 max-w-4xl mx-auto px-6 border-s border-gray-200 pl-6 relative">
          {experiences.timeline.map((exp, index) => (
            <li key={index} className="mb-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white">
                {exp.type === "work" ? (
                  <MdWorkOutline className="w-4 h-4 text-blue-700" />
                ) : (
                  <HiOutlineAcademicCap className="w-5 h-5 text-blue-700" />
                )}
              </span>
              <h2 className="text-xl font-semibold">
                {exp.role} —{" "}
                <span className="text-gray-700">{exp.institution}</span>
              </h2>
              <p className="text-sm text-gray-500 italic">
                {exp.location} — {exp.date}
              </p>
              <p className="mt-2 text-gray-700">{exp.description}</p>
            </li>
          ))}
        </ol>
      </section>

      {/* <section className="mt-12 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {experiences.title}
        </h2>

        <ol className="space-y-8 max-w-4xl mx-auto px-6 border-s border-gray-200 pl-6 relative">
          {experiences.timeline.map((exp, index) => (
            <li key={index} className="mb-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white">
                {exp.type === "work" ? (
                  <MdWorkOutline className="w-4 h-4 text-blue-700" />
                ) : (
                  <HiOutlineAcademicCap className="w-5 h-5 text-blue-700" />
                )}
              </span>
              <h2 className="text-xl font-semibold">
                {exp.role} —{" "}
                <span className="text-gray-700">{exp.institution}</span>
              </h2>
              <p className="text-sm text-gray-500 italic">
                {exp.location} — {exp.date}
              </p>
              <p className="mt-2 text-gray-700">{exp.description}</p>
            </li>
          ))}
        </ol>
      </section> */}
      <section className="mt-16 px-6 max-w-4xl mx-auto">
        {FeaturedPublications()}
      </section>

      <section className="mt-16 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {strings.experiencePage.skills.programming.title}
        </h2>

        <ul className="max-w-4xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {strings.experiencePage.skills.programming.list.map(
            (skill, index) => (
              <li key={index} className="border rounded-lg p-4">
                <span className="font-semibold text-lg">{skill.name}</span>
                <div className="mt-2 flex flex-wrap space-x-4 ml-4">
                  {skill.language.map((lang, langIndex) => (
                    <div
                      key={langIndex}
                      className="flex items-center space-x-2 mr-4 mb-2"
                    >
                      <img
                        src={lang.logo}
                        alt={`${lang.name} logo`}
                        className="w-6 h-6 bg-transparent"
                        style={{ backgroundColor: "transparent" }}
                      />
                      <span>{lang.name}</span>
                    </div>
                  ))}
                </div>
              </li>
            )
          )}
        </ul>
      </section>

      <section className="mt-16 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {" "}
          {strings.experiencePage.skills.competences.title}
        </h2>

        <ul className="max-w-4xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {strings.experiencePage.skills.competences.list.map(
            (skill, index) => (
              <li key={index} className="border rounded-lg p-4">
                <span className="font-semibold text-lg">{skill.title}</span>
                <ul className="mt-2 space-y-2 ml-4">
                  {skill.list.map((lang, langIndex) => (
                    <li key={langIndex} className="flex items-center space-x-2">
                      <span className="text-xl leading-none">•</span>
                      <span>{lang.name}</span>
                    </li>
                  ))}
                </ul>
              </li>
            )
          )}
        </ul>
      </section>

      <section className="mt-16 px-6 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">
          {" "}
          {strings.experiencePage.skills.languages.title}
        </h2>

        <ul className="max-w-4xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {strings.experiencePage.skills.languages.list.map(
            (lang, langIndex) => (
              <li key={langIndex} className="border rounded-lg p-4">
                <span className="font-semibold text-lg">{lang.name}</span>
                <div className="mt-2 flex items-center space-x-2">
                  <img
                    src={lang.flag}
                    alt={`${lang.name} flag`}
                    className="w-9 h-auto aspect-[3/2] object-cover"
                  />
                  <span>{lang.level}</span>
                </div>
              </li>
            )
          )}
        </ul>
      </section>
    </main>
  );
}
